import { z } from 'zod';

export const mediaTypeSchema = z.enum(['image', 'video', 'file']);

export const mediaUploaderSchema = z.object({
    id: z.number().int(),
    name: z.string().min(1),
});

export const mediaDtoSchema = z.object({
    id: z.number().int(),
    calendar_entry_id: z.number().int(),
    uploader: mediaUploaderSchema,
    type: mediaTypeSchema,
    mime_type: z.string().min(1),
    original_filename: z.string().min(1),
    title: z.string().nullable().optional(),
    file_size: z.number().int().nonnegative(),
    created_at: z.string(),
    url: z.string().min(1),
});

export const mediaListSchema = z.array(mediaDtoSchema);

export const mediaUploadResponseSchema = mediaListSchema;

export const deleteMediaInputSchema = z.object({
    mediaId: z.number().int(),
    entryId: z.number().int(),
});

export const renameMediaInputSchema = z.object({
    mediaId: z.number().int(),
    entryId: z.number().int(),
    title: z.string().trim().min(1).max(255),
});

export const downloadMediaZipInputSchema = z.object({
    entryId: z.number().int(),
    mediaIds: z.array(z.number().int()).min(1),
});

export type CalendarEntryMedia = z.infer<typeof mediaDtoSchema>;
export type CalendarEntryMediaList = z.infer<typeof mediaListSchema>;
export type DeleteMediaInput = z.infer<typeof deleteMediaInputSchema>;
export type RenameMediaInput = z.infer<typeof renameMediaInputSchema>;
export type DownloadMediaZipInput = z.infer<typeof downloadMediaZipInputSchema>;
